module.exports = __webpack_public_path__ + "static/media/Kargoshaie.6758a625.png";